import React, {useRef} from 'react'
import HeroLanding from '../component/LandingPageComponentTwo/HeroLanding/HeroLanding'
import RequestConversationBar from '../component/LandingPageComponentTwo/RequestConversationBar/RequestConversationBar'
import StatsSection from '../component/LandingPageComponentTwo/StatsSection/StatsSection'
import MarqueeScroller from '../component/LandingPageComponentTwo/MarqueeScroller/MarqueeScroller'
import NewApproachSection from '../component/LandingPageComponentTwo/NewApproachSection/NewApproachSection'
import CareDeliverySection from '../component/LandingPageComponentTwo/CareDeliverySection/CareDeliverySection'
import FiveMovementsSection from '../component/LandingPageComponentTwo/FiveMovementsSection/FiveMovementsSection'
import MembershipProgramSection from '../component/LandingPageComponentTwo/MembershipProgramSection/MembershipProgramSection'
import MembershipTiersSection from '../component/LandingPageComponentTwo/MembershipTiersSection/MembershipTiersSection'
import FaqSection from '../component/LandingPageComponentTwo/FaqSection/FaqSection'
import TeamLedCareSection from '../component/LandingPageComponentTwo/TeamLedCareSection/TeamLedCareSection'
import TestimonialsNew from '../component/InstaImageGallery/InstaImageGallery'
import LandingContactSection from '../component/LandingPageComponentTwo/LandingContactSection/LandingContactSection'
import Footer from '../component/LandingPageComponentTwo/Footer/Footer'

function LandingPageTwo() {
  return (
    <div>
        <HeroLanding/>

        <RequestConversationBar/>

        <StatsSection/>

        <MarqueeScroller/>

        <NewApproachSection/>

        <CareDeliverySection/>

        <FiveMovementsSection/>

        <div id="Membership-section">
        <MembershipProgramSection/>
        </div>

        <MembershipTiersSection/>

        <FaqSection/>

        <div id="Team-led-care">
        <TeamLedCareSection/>
        </div>
        
        <TestimonialsNew/>

        <LandingContactSection/>

        <Footer/>

    </div>
  )
}

export default LandingPageTwo